module.exports = __webpack_public_path__ + "assets/images/Custom-Channel.svg";